import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateOperatingProgram',
})
export class TranslateOperatingProgramPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value && this.customTranslationsService.OPERATING_PROGRAMS[value]) {
      return this.translateService.instant(
        this.customTranslationsService.OPERATING_PROGRAMS[value] ?? value
      );
    }

    return value;
  }
}
